import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import NotificationsList from './NotificationsList';
import NotificationDetails from './NotificationDetails';
import NotificationService from '../../../apiclients/NotificationService';
import WebsocketService from '../../../apiclients/WebsocketService';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import StoreController from '@projeccions-pdc/frontend-storage';
import { isSmartphone } from '../../../helpers';
import LocalizedStrings from '../../Localization/localization';
import AppContext from '../../../AppContext';
import './Notifications.css';

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedNotificationId: undefined,
            notifications: [],
            smartphoneView: undefined
        };

        let appContext = new AppContext();
        let currentUserSub = appContext.getMyInfo().userSub;
        this._StoreController = new StoreController(appContext.getPlatformId(), currentUserSub);
    }

    handleSizeChange = match => {
        this.setState({ smartphoneView: match });
    };

    componentDidMount() {
        let appContext = new AppContext();
        appContext.addObserver('notisComponent', this);
        this.removeListener = isSmartphone(match => this.handleSizeChange(match));
        this.loadNotifications();
        this.openWebSocketSubscription();
    }

    componentWillUnmount() {
        WebsocketService.unsubscribe(this.wsSubId);
        this.removeListener();
        let appContext = new AppContext();
        appContext.removeObserver('notisComponent');
    }

    openWebSocketSubscription = async () => {
        this.wsSubId = await WebsocketService.subscribe(data => {
            if (data.payload.messageCountUpdated === undefined) {
                // console.log('ei si')
                // setTimeout(() => this.loadNotifications(0), 3000);
                this.loadNotifications(0);
            }
        }, 'NOTIFICATION');
    };

    notifyDataHasChanged = async () => {
        await this.loadNotifications();
    };

    loadNotifications = async (cacheTTL = undefined) => {
        try {
            let notifications = this._StoreController.get('notifications');

            this.setState({ notifications });

            let response = await NotificationService.listMessages(cacheTTL);
            // console.log('notifications', response);
            this.setState({ notifications: response });
            this._StoreController.set('notifications', response);
        } catch (err) {
            console.log(err);
        }
    };

    openNotification = messageId => {
        const notifications = cloneDeep(this.state.notifications);
        let currentNotification = notifications.find(x => x.messageId === messageId);
        if (currentNotification.status === 'new') {
            currentNotification.status = 'checked';
            this.checkMessage(messageId);
        }
        this.setState({
            selectedNotificationId: messageId,
            notifications
        });
    };

    closeNotification = () => {
        this.setState({ selectedNotificationId: undefined });
    };

    checkMessage = async messageId => {
        try {
            await NotificationService.checkMessage(messageId);
            //let response =
            // console.log('checkMessage', response);
        } catch (err) {
            console.log(err);
        }
    };

    deleteMessage = async messageId => {
        try {
            console.log('deleteMessagex', messageId);
            await NotificationService.deleteMessage(messageId);
            let newNotis = this.state.notifications.filter(noti => {
                return noti.messageId !== messageId;
            });
            this._StoreController.set('notifications', newNotis);
            this.setState({ selectedNotificationId: undefined, notifications: newNotis });
        } catch (err) {
            console.log(err);
            await this.loadNotifications();
        }
    };

    newNotification = () => {
        this.props.history.push('/notifications/new');
    };

    render() {
        let currentNotification;
        if (this.state.selectedNotificationId) {
            currentNotification = this.state.notifications.find(x => x.messageId === this.state.selectedNotificationId);
        }

        return (
            <Fragment>
                <div className={`App-page-background ${this.props.backgroundColor}`} />
                <div className="inbox-container">
                    <div
                        style={{
                            color: '#fff',
                            fontSize: '25px',
                            fontWeight: 'bolder',
                            textAlign: 'left',
                            marginTop: '30px',
                            marginBottom: '20px'
                        }}
                    >
                        {LocalizedStrings.notifications}
                    </div>
                    {(this.state.smartphoneView === false ||
                        (this.state.smartphoneView === true && this.state.selectedNotificationId === undefined)) && (
                            <NotificationsList
                                notifications={this.state.notifications}
                                onNotificationSelected={this.openNotification}
                                selectedNotificationId={this.state.selectedNotificationId}
                                handleNewNotification={this.newNotification}
                                customizationStyle={this.props.customizationStyle}
                                isSmartphone={this.state.smartphoneView}
                            />
                        )}
                    {(this.state.smartphoneView === false ||
                        (this.state.smartphoneView === true && this.state.selectedNotificationId !== undefined)) && (
                            <NotificationDetails
                                notification={currentNotification}
                                onDelete={this.deleteMessage}
                                openContent={this.props.openContent}
                                openFileViewer={this.props.openFileViewer}
                                isSmartphone={this.state.smartphoneView}
                                onCloseNotification={this.closeNotification}
                                onOpenLink={this.props.onOpenLink}
                            />
                        )}
                </div>
            </Fragment>
        );
    }
}
Notifications.propTypes = {
    history: PropTypes.object.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    customizationStyle: PropTypes.object.isRequired,
    onOpenLink: PropTypes.func.isRequired,
    backgroundColor: PropTypes.string.isRequired,
};

export default withRouter(Notifications);
